import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-artstamm-template',
  imports: [],
  templateUrl: './artstamm.template.html',
  styleUrls: ['./artstamm.template.css'],
})
export class ArtstammTemplate implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
